<template>
  <v-container id="group-contacts" fluid tag="section">
    <!-- <manage-billpay-patients /> -->
    <manage-ehr-patients />
    <!-- <manage-pos-patients /> -->
  </v-container>
</template>

<script>
  /* eslint-disable */
export default {
  components: {
    ManageEhrPatients: () => import("../../components/manage-ehr-patients/manage-ehr-patients.vue")
  },
  props: {},
  data: () => ({
    activeTab: "pos-patients" // Other option: 'billpay-patients'
  }),

  computed: {},

  watch: {},

  created() {},

  methods: {
    _switchTab(tab) {
      this.activeTab = tab;
    }
  }
};
</script>

<style lang="scss">
.tabSwitcher {
  width: 100%;
  display: flex;
  margin-bottom: 3rem;
  justify-content: center;
  align-items: center;
  .tabSwitcherInnerWRapper {
    padding: 5px 8px;
    border: 1px solid #00a65f;
    border-radius: 25px;
    display: flex;
    .tab {
      padding: 10px 45px;
      font-size: 14px;
      cursor: pointer;
      color: #00a65f;
      font-weight: 600;
      &.selected {
        box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.2);
        color: white;
        background-color: #00a65f;
        cursor: unset;
        border-radius: 25px;
      }
    }
  }
}
</style>
